'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'file-excel';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f1c3';
var svgPathData = 'M365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448zM192 308.1L149.1 246.8c-5.062-7.25-15.06-9-22.28-3.938c-7.25 5.062-9 15.05-3.938 22.28L172.5 336L122.9 406.8c-5.062 7.234-3.312 17.22 3.938 22.28C129.6 431.1 132.8 432 135.1 432c5.047 0 10.02-2.375 13.12-6.828L192 363.9l42.89 61.27C237.1 429.6 242.1 432 248 432c3.172 0 6.375-.9375 9.156-2.891c7.25-5.062 9-15.05 3.938-22.28L211.5 336l49.58-70.83c5.062-7.234 3.312-17.22-3.938-22.28s-17.22-3.312-22.28 3.938L192 308.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileExcel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;